// @flow
import React from "react"
import type { EnumValue } from "data/enums/types"
import EnumFilter from "searchFilters/Shared/EnumFilter"

type Props = {|
  onChange: (?(EnumValue[])) => mixed,
  value: ?(EnumValue[]),
|}

const ProductFilter = (p: Props) => <EnumFilter {...p} paramKey="product" />

export default ProductFilter



// WEBPACK FOOTER //
// ./src/searchFilters/FilterComponents/ProductFilter.js